var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 426,
    viewBox: "0 0 183 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_14725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.261 273.602L89.9904 276.039L87.029 290.059L84.0675 276.039L70.7598 273.565L83.9926 270.341L87.029 257.108L90.0279 270.341L103.261 273.602Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5287 333.282L47.1063 334.669L45.4194 342.504L43.77 334.669L36.3477 333.282L43.7325 331.483L45.4194 324.098L47.1063 331.483L54.5287 333.282Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9387 113.799L87.5163 115.186L85.8294 122.983L84.18 115.186L76.7577 113.799L84.1425 112L85.8294 104.577L87.5163 112L94.9387 113.799Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7019 262.32C25.1791 262.389 24.6993 262.646 24.3517 263.043C24.0042 263.439 23.8125 263.948 23.8125 264.476C23.8125 265.003 24.0042 265.512 24.3517 265.909C24.6993 266.305 25.1791 266.562 25.7019 266.631C26.2246 266.562 26.7044 266.305 27.052 265.909C27.3996 265.512 27.5912 265.003 27.5912 264.476C27.5912 263.948 27.3996 263.439 27.052 263.043C26.7044 262.646 26.2246 262.389 25.7019 262.32Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29764 158.145C0.935954 158.202 0.606553 158.386 0.368654 158.664C0.130755 158.943 0 159.297 0 159.663C0 160.029 0.130755 160.383 0.368654 160.662C0.606553 160.94 0.935954 161.124 1.29764 161.181C1.65932 161.124 1.98878 160.94 2.22668 160.662C2.46458 160.383 2.59533 160.029 2.59533 159.663C2.59533 159.297 2.46458 158.943 2.22668 158.664C1.98878 158.386 1.65932 158.202 1.29764 158.145Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.204 422.799C125.842 422.856 125.513 423.04 125.275 423.318C125.037 423.597 124.906 423.951 124.906 424.317C124.906 424.683 125.037 425.037 125.275 425.316C125.513 425.594 125.842 425.778 126.204 425.835C126.566 425.778 126.895 425.594 127.133 425.316C127.371 425.037 127.502 424.683 127.502 424.317C127.502 423.951 127.371 423.597 127.133 423.318C126.895 423.04 126.566 422.856 126.204 422.799Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.696 408.78C144.602 408.78 143.553 409.215 142.78 409.988C142.007 410.761 141.572 411.81 141.572 412.904C141.572 413.997 142.007 415.046 142.78 415.82C143.553 416.593 144.602 417.027 145.696 417.027C146.789 417.027 147.838 416.593 148.612 415.82C149.385 415.046 149.819 413.997 149.819 412.904C149.819 411.81 149.385 410.761 148.612 409.988C147.838 409.215 146.789 408.78 145.696 408.78Z",
    fill: "#FFC727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_14725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 425,
    fill: "white",
    transform: "translate(0 0.381836)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.e6ef3ba229a386624412f6564c9bc489.svg";
export { ForwardRef as ReactComponent };